package gr.tech.GRAttestation.styles.grstyles

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import gr.tech.GRAttestation.styles.defaultText
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms

val termsListStyle = CssStyle {
    base {
        Modifier
            .fontWeight(FontWeight.Bold)
            .color(Theme.DarkGreen.rgb)
    }
}

val termsParagraphStyle = CssStyle {
    base {
        Modifier
            .defaultText()
            .fontSize(1.cssRem)
            .color(Colors.Black)
    }
}

val buttonColorFadeStyle = CssStyle {
    base {
        Modifier
            .color(Theme.DarkGreen.rgb)
            .transition(Transition.all(250.ms))
    }
    hover {
        Modifier
            .color(Theme.MediumGreen.rgb)
    }
}